<script setup lang="ts">
import { computed } from 'vue';
import BaseModal from '../ui/BaseModal.vue';
import I18nHtml from '../ui/I18nHtml.vue';
import { useModalStore, ModalType } from '@/stores/modal.ts';
import { $t } from '@/composables/translations/useTranslate.ts';

const modalStore = useModalStore();

const isOpen = computed({
  get: () => modalStore.isModalOpen(ModalType.MORE_OPTIONS),
  set: (value: boolean) => {
    if (!value) {
      modalStore.closeModal(ModalType.MORE_OPTIONS);
    }
  },
});

const contentFallback = `<p><strong>Darf's ein bisschen mehr sein?</strong></p>
<ul>
  <li>Ihr reist mit mehr als 4 Kindern pro Zimmer?</li>
  <li>Ihr reist mit mehr als 4 Erwachsenen pro Zimmer?</li>
  <li>Ihr reist mit mehr als 9 Personen?</li>
</ul>
<p>Dann freut sich unser Beratungsteam auf euren Anruf</p>
<p><strong><a href="tel:+4951140079900">+49 (0)511 400 799-0</a></strong></p>
<p><small>(Mo - Fr 9:00 - 13:00 Uhr und 14:00 - 18:00 Uhr)</small></p>`;
</script>

<template>
  <BaseModal
    v-model:open="isOpen"
    :title="$t('ibe.common.more-options', 'Weitere Optionen')"
    variant="centered"
    size="md"
  >
    <I18nHtml
      block
      tag="div"
      class="more-options-content text-gray-900"
      key-name="ibe.modal.more-options-content"
      :fallback="contentFallback"
    />
  </BaseModal>
</template>

<style scoped>
/*
 * Typography for the CMS-authored content.
 */
.more-options-content :deep(p) {
  margin-bottom: 0.5rem;
}

/* Headline sits further from the list, matching the previous hardcoded layout. */
.more-options-content :deep(p:first-child) {
  margin-bottom: 1rem;
}

.more-options-content :deep(strong),
.more-options-content :deep(b) {
  font-weight: 600;
}

.more-options-content :deep(ul),
.more-options-content :deep(ol) {
  margin-bottom: 1.5rem;
  padding-left: 1.25rem;
  list-style: disc;
}

.more-options-content :deep(ol) {
  list-style: decimal;
}

.more-options-content :deep(li + li) {
  margin-top: 0.5rem;
}

.more-options-content :deep(small) {
  font-size: 0.875rem;
  color: #4b5563; /* gray-600 */
}

.more-options-content :deep(a) {
  text-decoration: underline;
}

.more-options-content :deep(> *:last-child) {
  margin-bottom: 0;
}
</style>
